import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Hub from "./pages/Hub";
import OTCApp from "./pages/OTCApp";
import VersionControlApp from "./pages/VersionControlApp";
import ControllersApp from "./pages/ControllersApp";
import EnvicomDemoApp from "./pages/EnvicomDemoApp";
import UserManagement from "./pages/UserManagement";

const BADGE_40 = {
  label: "enviCoM 4.0",
  className: "border-envicom-blue/40 bg-envicom-blue/10 text-envicom-blue",
};
const BADGE_LITE = {
  label: "enviCoM Lite",
  className: "border-envicom-teal/40 bg-envicom-teal/10 text-envicom-teal",
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Hub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apps/otc"
            element={
              <ProtectedRoute appId="otc">
                <OTCApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apps/version-control"
            element={
              <ProtectedRoute appId="version_control">
                <VersionControlApp
                  apiPath="/versions"
                  appId="version_control"
                  title="Version Control"
                  subtitle="Track every enviCoM 4.0 release and the changes that went into it."
                  productBadge={BADGE_40}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apps/controllers"
            element={
              <ProtectedRoute appId="controllers">
                <ControllersApp
                  apiPath="/controllers"
                  appId="controllers"
                  title="Controllers"
                  subtitle="Registry of every enviCoM 4.0 chamber in the field — firmware, customer, update history."
                  productBadge={BADGE_40}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apps/demo"
            element={
              <ProtectedRoute appId="envicom_demo">
                <EnvicomDemoApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apps/lite-version-control"
            element={
              <ProtectedRoute appId="envicom_lite_versions">
                <VersionControlApp
                  apiPath="/lite/versions"
                  appId="envicom_lite_versions"
                  title="Version Control"
                  subtitle="Track every enviCoM Lite release and the changes that went into it."
                  productBadge={BADGE_LITE}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apps/lite-controllers"
            element={
              <ProtectedRoute appId="envicom_lite_controllers">
                <ControllersApp
                  apiPath="/lite/controllers"
                  appId="envicom_lite_controllers"
                  title="Controllers"
                  subtitle="Registry of every enviCoM Lite chamber in the field — firmware, customer, update history."
                  productBadge={BADGE_LITE}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute superAdminOnly>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Hub />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}
